import {
    GET_REPORTING_REQUIREMENTS_BY_SPONSER_ID,
    ADD_OR_UPDATE_REPORTING_REQUIREMENT,
    DELETE_REPORTING_REQUIREMENT,
    GET_REPORTING_SUBMISSIONS_BY_REQUIREMENT_ID,
    GET_FACILITY_FLAG_STATUS_BY_SPONSER_ID,
    RECORD_REPORTING_SUBMISSION,
    GET_METRIC_RESULTS_BY_SUBMISSION_ID,
    SET_REPORTING_COMPLIANCE_STATUS,
    EXPORT_COVENANT_RESULTS_BY_SPONSER_ID,
    SET_INSTITUTION_ACTUAL_VALUE,
    GET_CYCLES_FOR_USER,
    SEND_MANUAL_REMINDER,
} from "../constants/constants";
import { instance } from "./apiRequest";

let _ReportingService = {
    async getReportingRequirementsBySponserId(sponserId) {
        return await instance.post(GET_REPORTING_REQUIREMENTS_BY_SPONSER_ID, { sponserId: sponserId });
    },
    async addOrUpdateReportingRequirement(reqObj) {
        return await instance.post(ADD_OR_UPDATE_REPORTING_REQUIREMENT, reqObj);
    },
    async deleteReportingRequirement(reportingRequirementId) {
        return await instance.post(DELETE_REPORTING_REQUIREMENT, { reportingRequirementId: reportingRequirementId });
    },
    async getReportingSubmissionsByRequirementId(reportingRequirementId) {
        return await instance.post(GET_REPORTING_SUBMISSIONS_BY_REQUIREMENT_ID, { reportingRequirementId: reportingRequirementId });
    },
    async getFacilityFlagStatusBySponserId(sponserId) {
        return await instance.post(GET_FACILITY_FLAG_STATUS_BY_SPONSER_ID, { sponserId: sponserId });
    },
    async recordReportingSubmission(reqObj) {
        return await instance.post(RECORD_REPORTING_SUBMISSION, reqObj);
    },
    async getMetricResultsBySubmissionId(reportingSubmissionId) {
        return await instance.post(GET_METRIC_RESULTS_BY_SUBMISSION_ID, { reportingSubmissionId: reportingSubmissionId });
    },
    async setComplianceStatus(reqObj) {
        return await instance.post(SET_REPORTING_COMPLIANCE_STATUS, reqObj);
    },
    async exportCovenantResultsBySponserId(sponserId) {
        return await instance.post(EXPORT_COVENANT_RESULTS_BY_SPONSER_ID, { sponserId: sponserId });
    },
    async setInstitutionActualValue(reqObj) {
        return await instance.post(SET_INSTITUTION_ACTUAL_VALUE, reqObj);
    },
    // Reports Enhancement (Sept 2026): scoped, chip-counted, paginated cycle list backing the new
    // unified Reports screens (requirements #5/#6/#7).
    async getCyclesForUser(reqObj) {
        return await instance.post(GET_CYCLES_FOR_USER, reqObj);
    },
    async sendManualReminder(reqObj) {
        return await instance.post(SEND_MANUAL_REMINDER, reqObj);
    },
}
export default _ReportingService;
